export const useFontStore = defineStore("font-store", () => {
    const { t } = useI18n();

    const fontFamilies = [
        { label: t("fonts.inter"), value: "sans", class: "font-sans" },
        { label: t("fonts.lexend"), value: "display", class: "font-display" },
        { label: t("fonts.roboto"), value: "roboto", class: "font-roboto" },
        {
            label: t("fonts.open-sans"),
            value: "open-sans",
            class: "font-open-sans",
        },
        { label: t("fonts.lato"), value: "lato", class: "font-lato" },
        {
            label: t("fonts.montserrat"),
            value: "montserrat",
            class: "font-montserrat",
        },
        { label: t("fonts.raleway"), value: "raleway", class: "font-raleway" },
        { label: t("fonts.poppins"), value: "poppins", class: "font-poppins" },
        {
            label: t("fonts.source-sans-pro"),
            value: "source-sans-pro",
            class: "font-source-sans-pro",
        },
        { label: t("fonts.nunito"), value: "nunito", class: "font-nunito" },
        { label: t("fonts.ubuntu"), value: "ubuntu", class: "font-ubuntu" },
        {
            label: t("fonts.merriweather"),
            value: "merriweather",
            class: "font-merriweather",
        },
        {
            label: t("fonts.playfair-display"),
            value: "playfair-display",
            class: "font-playfair-display",
        },
        {
            label: t("fonts.quicksand"),
            value: "quicksand",
            class: "font-quicksand",
        },
        { label: t("fonts.oswald"), value: "oswald", class: "font-oswald" },
        { label: t("fonts.pt-sans"), value: "pt-sans", class: "font-pt-sans" },
        {
            label: t("fonts.work-sans"),
            value: "work-sans",
            class: "font-work-sans",
        },
        {
            label: t("fonts.noto-sans"),
            value: "noto-sans",
            class: "font-noto-sans",
        },
        {
            label: t("fonts.josefin-sans"),
            value: "josefin-sans",
            class: "font-josefin-sans",
        },
        { label: t("fonts.karla"), value: "karla", class: "font-karla" },
        {
            label: t("fonts.fira-sans"),
            value: "fira-sans",
            class: "font-fira-sans",
        },
        { label: t("fonts.cabin"), value: "cabin", class: "font-cabin" },
    ];

    return {
        fontFamilies,
        findFontFamily(family: string) {
            return fontFamilies.find(({ value }) => value === family);
        },
    };
});
